import { RoomStatusProps } from "../../../../interfaces/RoomStatusProps.interface"
import RoomCardHeader from "../../shared/RoomCardHeader/RoomCardHeader"
import VerticalContainer from "../../shared/VerticalContainer/VerticalContainer"
import Wrapper from "../../shared/Wrapper/Wrapper"
import { useApartadaCountdown } from "../../../../hooks/useApartadaCountdown"

import "../Blocked/Blocked.css"

const Apartada = (props: RoomStatusProps) => {
    const { timeLeft } = useApartadaCountdown(props.dateStatusChanged)

    return (
        <Wrapper bgColor={"var(--card-gray)"}>
            <RoomCardHeader
                hasIncidences={props.hasIncidences}
                iconName={"LockFill"}
                roomNumber={props.roomNumber}
                roomTypeName={props.roomTypeName}
                iconBgColor="var(--bloqueada)"
            />
            <VerticalContainer>
                <div className="room-card--md--blocked__timer">{timeLeft}</div>
                <div className="room-card--md--blocked__description">Apartada</div>
            </VerticalContainer>
        </Wrapper>
    )
}

export default Apartada
